import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ClockIcon } from '@yonderland/andes-icons';
import { TextAlpha } from '@yonderland/andes-react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useTranslation } from 'react-i18next';
import { TIMEZONE_BY_MARKET } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { StoreInfoTag } from './StoreInfoTag';
dayjs.extend(utc);
dayjs.extend(timezone);
export const StoreActualInfoTag = ({ scheduleEntries }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    const { market } = useAemConfig();
    const todayDate = dayjs().tz(TIMEZONE_BY_MARKET[market]);
    const todayTimeInMinutes = todayDate.hour() * 60 + todayDate.minute();
    const todayIndex = scheduleEntries.findIndex(entry => dayjs().isSame(entry.date, 'day')); // use new dayjs instance to avoid an issue comparing different timezones
    const todaySchedule = scheduleEntries[todayIndex];
    const getTranslateKey = (prefix) => {
        return todaySchedule.isExceptional ? `${prefix}.exceptionally` : `${prefix}.text`;
    };
    const currentlyOpened = !todaySchedule.closed &&
        todayTimeInMinutes >= todaySchedule.openTimeInMinutes &&
        todayTimeInMinutes < todaySchedule.closeTimeInMinutes;
    const openingLaterToday = !todaySchedule.closed && todayTimeInMinutes < todaySchedule.openTimeInMinutes;
    const openingTomorrow = !scheduleEntries[todayIndex + 1].closed;
    const openingLater = scheduleEntries.slice(todayIndex + 2).find(entry => !entry.closed);
    const indicationColor = currentlyOpened ? 'success' : 'error';
    const getText = () => {
        if (currentlyOpened) {
            return t(getTranslateKey('store.open.till'), { endHour: todaySchedule.closingHour });
        }
        if (openingLaterToday) {
            return t('store.open.from.text', { startHour: todaySchedule.openingHour });
        }
        if (openingTomorrow) {
            return t(getTranslateKey('store.open.tomorrow'), {
                startHour: scheduleEntries[todayIndex + 1].openingHour,
            });
        }
        if (openingLater) {
            return t(getTranslateKey('store.open.other'), {
                weekday: t(`store.day.${openingLater.day.toLowerCase()}`).toLowerCase(),
                startHour: openingLater.openingHour,
            });
        }
        return t('store.closed.txt');
    };
    return (_jsx(StoreInfoTag, { icon: ClockIcon, children: _jsx(TextAlpha, { color: indicationColor, as: "span", children: getText() }) }));
};
